var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.791 10.1c.039-.287.058-.584.058-.9 0-.307-.02-.613-.067-.9l1.945-1.515a.47.47 0 0 0 .115-.585l-1.84-3.181a.468.468 0 0 0-.565-.211l-2.29.92a6.77 6.77 0 0 0-1.553-.9L11.249.392a.464.464 0 0 0-.46-.393h-3.68a.454.454 0 0 0-.45.393l-.345 2.434a6.919 6.919 0 0 0-1.553.9l-2.29-.92a.458.458 0 0 0-.566.212L.075 6.2c-.115.202-.077.45.115.585l1.945 1.514a5.624 5.624 0 0 0-.086.901c0 .297.02.613.067.9L.171 11.616a.47.47 0 0 0-.115.585l1.84 3.181c.115.211.354.278.565.211l2.29-.92c.48.364.987.67 1.553.9l.345 2.435c.048.23.23.393.46.393h3.68c.23 0 .422-.163.45-.393l.345-2.434a6.569 6.569 0 0 0 1.553-.9l2.29.92c.211.076.45 0 .566-.212l1.84-3.181c.115-.211.067-.45-.115-.585l-1.927-1.514ZM8.95 12.65a3.46 3.46 0 0 1-3.45-3.45 3.46 3.46 0 0 1 3.45-3.45 3.46 3.46 0 0 1 3.45 3.45 3.46 3.46 0 0 1-3.45 3.45Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/settingIcon.fd1ab989d6ae59ea3171cb66faa37bcb.svg";
export { ForwardRef as ReactComponent };